import { fileManageApi } from '@/api/index';
const getDefaultState = () => {
  return {
    currentProject: {}
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_CURRENTPROJECT: (state, currentProject) => {
    state.currentProject = currentProject
  }
}

const actions = {
  // 获取项目详情
  getProjectDetail ({ commit }, id) {
    return new Promise((resolve, reject) => {
      fileManageApi.getProjectDetail({ id }).then(res => {
        commit('SET_CURRENTPROJECT', res.data)
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })

  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

